import { DefaultNodeModel } from "@projectstorm/react-diagrams";
import { v4 as uuidv4 } from "uuid";

export class TriggerNodeModel extends DefaultNodeModel {
  constructor({
    id = `TriggerNode_${uuidv4()}`,
    color = "rgb(255,192,0)",
    position = { x: 100, y: 100 },
    nodeProperties = { Name: "New Trigger Node", TriggerType: "Entry Created", Type: "Trigger" },
  }) {
    super({
      id: id,
      name: nodeProperties?.Name,
      color: color,
      extras: { properties: nodeProperties },
    });
    this.setPosition(position.x, position.y);
    this.addOutPort("onTrigger");
  }
}
